<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="cross">
<p class="body"><br/></p>
<h1 class="part-number---IVP" title="Part 1: The Story that Shapes Cruciform Worship"><span class="text_color">Part 1</span></h1>
<h2 class="part-title---IVP sigil_not_in_toc" id="_idParaDest-3"><a id="_idTextAnchor016"></a><br/><br/><span class="large">The Story that <br/>Shapes Cruciform <br/>Worship<br/><br/></span></h2>
<p class="body"><span epub:type="pagebreak" id="page16" title="16"></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?1ed3b5cd